import { render, staticRenderFns } from "./wd-tag.vue?vue&type=template&id=1e90d7c6&scoped=true"
import script from "./wd-tag.vue?vue&type=script&lang=js"
export * from "./wd-tag.vue?vue&type=script&lang=js"
import style0 from "./wd-tag.vue?vue&type=style&index=0&id=1e90d7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90d7c6",
  null
  
)

export default component.exports